import React, { useState } from 'react';
import { Input, Switch } from 'antd';
import Modal from './../Modal/index';
import {
  BadgeIcon,
  Divider,
  MemberId,
  Row,
  Section,
  StatusLabel,
  Title,
  ToggleSpacer,
} from './NonmemberToggle.styled';

export const NonmemberToggle = ({
  onToggle,
  updateMemberId,
  memberId,
  isMember,
  amsContact,
}) => {
  //True means member and false means nonmember.
  const [switchState, setSwitchState] = useState(isMember); // If memberId, should be true
  const [editMode, setEditMode] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const updateContactValue = val => {
    setSwitchState(val);
    onToggle(val);
    if (!val && editMode) setEditMode(false); // Cancel edit mode if toggled off
  };

  const handleSwitchUpdate = val => {
    if (val === false && memberId) {
      // Throw up a modal to ask the user if they are sure they want to remove the member flag if the contact has a member id.
      setConfirmationModal(true);
    }
    updateContactValue(val);
  };

  const cancelConfirmationModal = () => {
    // Close modal and set back to member
    setConfirmationModal(false);
    setSwitchState(true);
  };

  const acceptConfirmationModal = () => {
    // Close modal after setting
    updateContactValue(false);
    updateMemberId('');
    setConfirmationModal(false);
  };

  const toggleEditMode = () => setEditMode(prev => !prev);

  const renderMemberId = () => {
    if (!memberId && amsContact) return null;
    if (editMode && !amsContact) {
      return (
        <Input
          onChange={event => updateMemberId(event.target.value)}
          defaultValue={memberId}
          type="text"
          size="small"
          style={{ width: 110 }}
        />
      );
    }
    return (
      <MemberId
        $clickable={!amsContact}
        onClick={amsContact ? undefined : toggleEditMode}
      >
        #{memberId || '-'}
      </MemberId>
    );
  };

  return (
    <Section>
      <Row>
        <BadgeIcon />
        <Title>Basic Info</Title>
        <Divider />
        {switchState ? (
          <>
            <StatusLabel $isMember>Member</StatusLabel>
            {renderMemberId()}
          </>
        ) : (
          <StatusLabel>Non-member</StatusLabel>
        )}
        {!amsContact && (
          <ToggleSpacer>
            <Switch
              size="small"
              checked={switchState}
              onClick={handleSwitchUpdate}
            />
          </ToggleSpacer>
        )}
      </Row>
      {confirmationModal && (
        <Modal
          title="Confirm"
          primaryButton={{ label: 'Yes', onClick: acceptConfirmationModal }}
          secondaryButton={{ label: 'Cancel' }}
          onClose={cancelConfirmationModal}
        >
          Changing this contact to be a nonmember will delete any saved Member
          ID for the contact. Proceed?
        </Modal>
      )}
    </Section>
  );
};
